import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    auth: {
      authorized: false,
      user: null,
      groupId: null,
      enterpriseId: null
    },
    role: null,
    userInfo: null
  },
  mutations: {
    isLoading (state, value) {
      state.isLoading = value
    },
    login (state, value) {
      state.auth.authorized = true
      state.auth.user = value
    },
    logout (state, value) {
      state.auth = {}
      state.role = null
      state.userInfo = null
    },
    setMe (state, value) {
      state.userInfo = state.auth.user && state.auth.user.token && !value.token
        ? { ...value, token: state.auth.user.token }
        : value
      state.role = value.role
    }
  },
  actions: {
    login: async ({ commit, dispatch }, user) => {
      const fileData = new window.FormData()
      fileData.append('email', user.email)
      fileData.append('password', user.password)
      fileData.append('device_name', 'web')
      const { data } = await api.post('/login', fileData)
      commit('login', data)
      return data
    },
    loginWithToken: async ({ commit, dispatch }, token) => {
      commit('login', { token })
      await dispatch('getUser')
    },
    logout: async ({ commit }, router) => {
      const { data } = await api.post('/logout')
      // this.$router.push({ name: 'Home' })
      commit('logout', data)
    },
    getUser: async ({ commit }) => {
      const { data } = await api.get('/me')
      commit('setMe', data)
    }
  },
  getters: {
    isLoading: state => state.isLoading,
    errorMessage: state => state.errorMessage,
    userInfo: state => state.userInfo,
    role: state => state.role,
    authorized: state => state.auth.authorized
  },
  modules: {
  },
  plugins: [
    createPersistedState(
      {
        key: 'livelearning',
        paths: [
          'auth',
          'userInfo',
          'role'
        ]
      }
    )
  ]
})
